import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h5>{`Track 1: Development Process and Practice`}</h5>
    <ul>
      <li parentName="ul">{`Have you ever encountered complicated and unexpected situations during the development process?`}</li>
      <li parentName="ul">{`The agenda of this track involves requirement refinement, team consensus establishment, software modeling, and improvement of the development process based on practical experience, etc. Let’s cut to the core of the problem, then find the pivot to solve problems!`}</li>
      <li parentName="ul">{`Also, all of the items in this agenda revolve around how to improve the team productivity of products/projects development and distill the complicated and trivial development process into a more simple, precise, and efficient way.`}</li>
      <li parentName="ul">{`The content includes but is not limited to:`}<ol parentName="li">
          <li parentName="ol">{`Agile/Extreme Development Method`}</li>
          <li parentName="ol">{`Modeling method`}</li>
          <li parentName="ol">{`Development flow improvement examples`}</li>
          <li parentName="ol">{`Requirement refinement`}</li>
          <li parentName="ol">{`Establishment of team consensus`}</li>
        </ol></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      